import { combineReducers } from "redux"

// Front
import Layout from "./layout/reducer"

// Authentication
import Login from "./auth/login/reducer"
import Account from "./auth/register/reducer"
import ForgetPassword from "./auth/forgetpwd/reducer"
import Profile from "./auth/profile/reducer"
import ReqRegister from "./auth/reqRegister/reducer"

// Users
import USERs from './users/reducer'

// GasProjects
import GasProjects from './gasProjects/reducer'

// AppMenus
import AppMenus from './appMenu/reducer'

// Executors
import Executors from './executors/reducer'

// Engineer
import Engineers from './engineers/reducer'

// QuarterTariffs
import QuarterTariffs from './quarterTariffs/reducer'

// Common
import Commons from './commons/reducer'

// Change Password
import ChangePassword from './auth/changePassword/reducer'

// Payment
import Payment from './payment/reducer'

// Accounting
import Accounting from './accounting/reducer'

// GasProjectProcesses
import GasProjectProcesses from './gasProjectProcesses/reducer'


// Supports
import Supports from './supports/reducer'

// EngPayment
import EngPayment from './engPayment/reducer'

// Finance Report
import FinanceReport from './finances/reducer'

// quotas
import Quotas from './quotas/reducer'

// Client
import Client from './client/reducer'

// PackageInstaller
import PackageInstaller from './packageInstaller/reducer'
// import PackageInstallerSlice from './packageInstaller/slice'

// Notifications
import Notifications from './notifications/reducer'

// Documents
import Documents from './documents/reducer'

// ProjectPackages
import ProjectPackages from './projectPackages/reducer'

// AiTraining
import AiTraining from './aiTraining/reducer'



const rootReducer = combineReducers({
  // public
  Layout,
  Login,
  Account,
  ForgetPassword,
  Profile,
  ReqRegister,
  USERs,
  GasProjects,
  AppMenus,
  Executors,
  Engineers,
  QuarterTariffs,
  Commons,
  ChangePassword,
  Payment,
  Accounting,
  GasProjectProcesses,
  Supports,
  EngPayment,
  FinanceReport,
  Quotas,
  Client,
  PackageInstaller,
  Notifications,
  Documents,
  ProjectPackages,
  AiTraining,
})

export default rootReducer
